var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { attrs: { "no-margin": "", "no-padding": "", xs: "12" } },
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-card",
                [
                  _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("settings")))]),
                  _c(
                    "w-card-content",
                    [
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { md: "6", xs: "12" } },
                            [
                              _c("w-input", {
                                attrs: { label: _vm.$ct("name"), fancy: "" },
                                model: {
                                  value: _vm.value.Name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.value, "Name", $$v)
                                  },
                                  expression: "value.Name",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { md: "6", xs: "12" } },
                            [
                              _c("w-input", {
                                attrs: {
                                  label: _vm.$ct("subject"),
                                  value: _vm.selectedSubject,
                                  fancy: "",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.onSubjectUpdate($event)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { md: "6", xs: "6" } },
                            [
                              _c("w-select", {
                                attrs: {
                                  items: _vm.reminderTemplateItems,
                                  label: _vm.$ct("reminder-num"),
                                  fancy: "",
                                },
                                model: {
                                  value: _vm.value.ReminderCount,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.value, "ReminderCount", $$v)
                                  },
                                  expression: "value.ReminderCount",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { md: "6", xs: "6" } },
                            [
                              _c("app-custom-lang-select", {
                                attrs: { label: _vm.$ct("lang"), fancy: "" },
                                on: {
                                  input: function ($event) {
                                    return _vm.updateLanguage()
                                  },
                                },
                                model: {
                                  value: _vm.selectedLang,
                                  callback: function ($$v) {
                                    _vm.selectedLang = $$v
                                  },
                                  expression: "selectedLang",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { md: "6", xs: "12" } },
                            [
                              _c("app-reminder-email-template-prop-select", {
                                attrs: {
                                  "cursor-position": _vm.cursorPosition,
                                  text: _vm.contentAsText,
                                },
                                on: {
                                  add: function ($event) {
                                    return _vm.addProp($event)
                                  },
                                  "add-link": _vm.addLink,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { md: "6", xs: "12" } },
                            [
                              _c(
                                "w-row",
                                { attrs: { "no-margin": "" } },
                                [
                                  _c("w-spacer"),
                                  _c("w-switch", {
                                    style: { marginTop: "15px" },
                                    attrs: {
                                      label: _vm.$ct("is-html"),
                                      right: "",
                                    },
                                    model: {
                                      value: _vm.value.IsHTML,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.value, "IsHTML", $$v)
                                      },
                                      expression: "value.IsHTML",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("app-mail-template-editor", {
                ref: "editor",
                attrs: { "is-html": _vm.value.IsHTML, value: _vm.selectedText },
                on: {
                  input: function ($event) {
                    return _vm.onContentUpdate($event)
                  },
                  "text-value": function ($event) {
                    _vm.contentAsText = $event
                  },
                  "cursor-position-change": function ($event) {
                    _vm.cursorPosition = $event
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }